// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatListSettingsSidebar_wrapper__m1154 {
  z-index: 5;
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  border-radius: var(--Corner-radius, 4px);
  background: #FFF;
  box-shadow: 0 0 8px 0 rgba(42, 98, 149, 0.25); }

.chatListSettingsSidebar_sourceContainer__3aigi {
  width: 260px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  column-gap: 6px;
  height: 32px; }

.chatListSettingsSidebar_applyButton__sAfu- {
  width: 100%;
  background: #FFF; }

.chatListSettingsSidebar_buttonsContainer__v-KvO {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 10px; }

.chatListSettingsSidebar_switchContainer__ZFO2d {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 18px; }

.chatListSettingsSidebar_title__bIW2V {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px; }

.chatListSettingsSidebar_subtitle__6Dbqg {
  font-weight: 600;
  font-size: 14px;
  line-height: 150%; }

.chatListSettingsSidebar_plainText__5l069 {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/chatsListSettingsSidebar/chatListSettingsSidebar.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,gBAAgB;EAChB,6CAA6C,EAAA;;AAG/C;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB,EAAA;;AAGrB;ECzBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AD4BnB;ECxBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB,EAAA;;AD0BnB;ECVE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDUjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.wrapper {\n  z-index: 5;\n  height: 100%;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  border-radius: var(--Corner-radius, 4px);\n  background: #FFF;\n  box-shadow: 0 0 8px 0 rgba(42, 98, 149, 0.25);\n}\n\n.sourceContainer {\n  width: 260px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: center;\n  column-gap: 6px;\n  height: 32px;\n}\n\n.applyButton {\n  width: 100%;\n  background: #FFF;\n}\n\n.buttonsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  column-gap: 10px;\n}\n\n.switchContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 18px;\n}\n\n.title {\n  @include h4\n}\n\n\n.subtitle {\n  @include h5\n}\n\n.plainText {\n  @include body2;\n  width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `chatListSettingsSidebar_wrapper__m1154`,
	"sourceContainer": `chatListSettingsSidebar_sourceContainer__3aigi`,
	"applyButton": `chatListSettingsSidebar_applyButton__sAfu-`,
	"buttonsContainer": `chatListSettingsSidebar_buttonsContainer__v-KvO`,
	"switchContainer": `chatListSettingsSidebar_switchContainer__ZFO2d`,
	"title": `chatListSettingsSidebar_title__bIW2V`,
	"subtitle": `chatListSettingsSidebar_subtitle__6Dbqg`,
	"plainText": `chatListSettingsSidebar_plainText__5l069`
};
export default ___CSS_LOADER_EXPORT___;
